import { RoleBaseDesignThemeSizeConfig } from './types';

const small: RoleBaseDesignThemeSizeConfig = {
  roleBaseDesign: {},
};

export default small;
